import { NgOptimizedImage } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { ShoppingCartItem } from '../../../models/shopping';
import { FileurlPipe } from '../../../pipes/fileurl.pipe';
import {
  extractShoppingCartItem,
  ProductAttrWithValue,
} from '../../../utils/cart';
import { Price } from '../../common/price/price';
@Component({
  selector: 'app-checkout-list-item',
  imports: [NgOptimizedImage, FileurlPipe, Price, MatBadgeModule],
  templateUrl: './checkout-list-item.html',
  styleUrl: './checkout-list-item.scss',
})
export class CheckoutListItem implements OnChanges {
  @Input({ required: true }) item!: ShoppingCartItem;

  image: string = '';
  attrs: ProductAttrWithValue[] = [];
  priced_attr?: ProductAttrWithValue;

  ngOnChanges(changes: SimpleChanges): void {
    this.update();
  }

  update() {
    const { image, attrs, priced_attr } = extractShoppingCartItem(this.item);
    this.image = image;
    this.attrs = attrs;
    this.priced_attr = priced_attr;
  }
}
